/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Strategy_Partner_Mag7x_SummaryInputs */

const en_strategy_partner_mag7x_summary = /** @type {(inputs: Strategy_Partner_Mag7x_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A designed, rules-based, equal-weight model portfolio tracking eight of the largest publicly listed companies: Apple, Microsoft, Nvidia, Alphabet, Amazon, Meta, Tesla, and SpaceX (via tokenized stock).`)
};

const de_strategy_partner_mag7x_summary = /** @type {(inputs: Strategy_Partner_Mag7x_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwickelt, um ein gleich gewichtetes Engagement in acht der größten Unternehmen der Welt zu bieten: die Magnificent 7 (Apple, Microsoft, NVIDIA, Alphabet, Amazon, Meta und Tesla) plus SpaceX.`)
};

const pt_br2_strategy_partner_mag7x_summary = /** @type {(inputs: Strategy_Partner_Mag7x_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criada para oferecer exposição com pesos iguais a oito das maiores empresas do mundo: as Magnificent 7 (Apple, Microsoft, NVIDIA, Alphabet, Amazon, Meta e Tesla) mais a SpaceX.`)
};

const tr_strategy_partner_mag7x_summary = /** @type {(inputs: Strategy_Partner_Mag7x_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dünyanın en büyük şirketlerinden sekizine, yani Magnificent 7'ye (Apple, Microsoft, NVIDIA, Alphabet, Amazon, Meta ve Tesla) ve ek olarak SpaceX'e eşit ağırlıklı yatırım sunmak üzere tasarlanmıştır.`)
};

const zh_cn2_strategy_partner_mag7x_summary = /** @type {(inputs: Strategy_Partner_Mag7x_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旨在为全球规模最大的八家公司提供等权重投资敞口，即“七巨头”（苹果、微软、英伟达、Alphabet、亚马逊、Meta 和特斯拉）加上 SpaceX。`)
};

const zh_hk2_strategy_partner_mag7x_summary = /** @type {(inputs: Strategy_Partner_Mag7x_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旨在為全球最大型公司的其中八家提供等權重投資，即「Magnificent 7」（Apple、Microsoft、NVIDIA、Alphabet、Amazon、Meta 及 Tesla）加上 SpaceX。`)
};

const ko_kr2_strategy_partner_mag7x_summary = /** @type {(inputs: Strategy_Partner_Mag7x_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`세계 최대 기업 여덟 곳, 즉 Magnificent 7(Apple, Microsoft, NVIDIA, Alphabet, Amazon, Meta, Tesla)과 SpaceX에 동일 비중으로 투자하도록 설계되었습니다.`)
};

const ru_ru2_strategy_partner_mag7x_summary = /** @type {(inputs: Strategy_Partner_Mag7x_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создана для равновзвешенных вложений в восемь крупнейших компаний мира: «Великолепную семёрку» (Apple, Microsoft, NVIDIA, Alphabet, Amazon, Meta и Tesla) плюс SpaceX.`)
};

const es_419_strategy_partner_mag7x_summary = /** @type {(inputs: Strategy_Partner_Mag7x_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diseñada para ofrecer exposición de igual ponderación a ocho de las empresas más grandes del mundo: las Magnificent 7 (Apple, Microsoft, NVIDIA, Alphabet, Amazon, Meta y Tesla) más SpaceX.`)
};

/**
* | output |
* | --- |
* | "A designed, rules-based, equal-weight model portfolio tracking eight of the largest publicly listed companies: Apple, Microsoft, Nvidia, Alphabet, Amazon, Me..." |
*
* @param {Strategy_Partner_Mag7x_SummaryInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const strategy_partner_mag7x_summary = /** @type {((inputs?: Strategy_Partner_Mag7x_SummaryInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Strategy_Partner_Mag7x_SummaryInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_strategy_partner_mag7x_summary(inputs)
	if (locale === "de") return de_strategy_partner_mag7x_summary(inputs)
	if (locale === "pt-BR") return pt_br2_strategy_partner_mag7x_summary(inputs)
	if (locale === "tr") return tr_strategy_partner_mag7x_summary(inputs)
	if (locale === "zh-CN") return zh_cn2_strategy_partner_mag7x_summary(inputs)
	if (locale === "zh-HK") return zh_hk2_strategy_partner_mag7x_summary(inputs)
	if (locale === "ko-KR") return ko_kr2_strategy_partner_mag7x_summary(inputs)
	if (locale === "ru-RU") return ru_ru2_strategy_partner_mag7x_summary(inputs)
	return es_419_strategy_partner_mag7x_summary(inputs)
});